import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
    apiKey: 'AIzaSyClF2ASFU91a6FtlT4vLbrOpaB5LJ0ZWpQ',
    authDomain: 'caramel-dde3f.firebaseapp.com',
    projectId: 'caramel-dde3f',
    storageBucket: 'caramel-dde3f.firebasestorage.app',
    messagingSenderId: '391597613736',
    appId: '1:391597613736:web:4259f450f6245aa35c589d',
    measurementId: 'G-TE42B6MV84',
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);
